import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IOrder } from '@care-portals/api-interfaces';
import { OrderRowComponent } from '../order-row/order-row.component';
import { APIService } from '../../../services/api/api.service';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'portals-emr-customer-unfulfilled-orders',
  templateUrl: './customer-unfulfilled-orders.component.html',
  styleUrls: [],
  standalone: true,
  imports: [CommonModule, OrderRowComponent, NzTableModule, NzToolTipModule]
})
export class CustomerUnfulfilledOrdersComponent implements OnInit, OnChanges {
  @Input() customerId: string;
  @Input() orderId: string;

  orders: IOrder[] = [];
  hiddenColumns: string[] = ['customer', 'state', 'actions'];
  @Output() showUnfulfilledOrders = new EventEmitter<boolean>();
  constructor(private api: APIService) {}

  ngOnInit() {
    if (this.customerId) {
      this.getOrders();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['customerId'] && !changes['customerId'].firstChange) {
      this.getOrders();
    }
  }

  getOrders() {
    if (!this.customerId) return;

    this.api
      .getAllOrders({
        customerId: this.customerId,
        status: [
          'awaiting_payment',
          'processing',
          'awaiting_requirements',
          'awaiting_requisition',
          'awaiting_results',
          'awaiting_script',
          'awaiting_fulfillment',
          'awaiting_shipment',
          'awaiting_pickup',
          'returned'
        ]
      })
      .subscribe(res => {
        this.orders = res as IOrder[];
        if (this.orderId) {
          this.orders = this.orders.filter(
            order => order.id !== Number(this.orderId)
          );
        }
        if (this.orders.length === 0) {
          this.showUnfulfilledOrders.emit(false);
        }
      });
  }
}
